<template>
    <bar-x-scrollable class="client-profile__details-bar">
        <h1 class="text-h6 text-primary q-ma-xs">
            {{ $filters.clientName(client) }}
        </h1>
        <div>
            <strong>File #:</strong> {{ client.fileRefNo }}
        </div>
        <div>
            <strong>Date of Loss:</strong> {{ $filters.date(client.dateOfLoss) }}
        </div>
        <div>
            <strong>DOB:</strong> {{ $filters.date(client.dateOfBirth) }}
        </div>
        <div>
            <social-accounts-btn :client-id="client.id" flat />
        </div>
    </bar-x-scrollable>
</template>

<style lang="scss" scoped>
.client-profile__details-bar {
    justify-content: space-between;
    > *:not(:first-child) {
        margin-left: 1.5rem;
    }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';
import SocialAccountsBtn from '@/social/account/AccountsBtn.vue';
import BarXScrollable from '@/layout/BarXScrollable.vue';
import { name as nameFilter } from '../client-filter';

export default defineComponent({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  filters: {
    clientName: nameFilter,
  },
  components: {
    'bar-x-scrollable': BarXScrollable,
    'social-accounts-btn': SocialAccountsBtn,
  },
});
</script>
